module.exports = __webpack_public_path__ + "public/StoreIcon/defaultFood.svg?37b1f8bf";